var map = {
	"./appstore.png": 2595,
	"./eldIcon.jpg": 2596,
	"./googleplay.png": 2597,
	"./logedIcon.png": 2598,
	"./logo_mobile.png": 2599,
	"./onBoarding.webp": 2600,
	"./smallLogo.png": 2601,
	"./spotlightGreen.png": 2602,
	"./spotlightGrey.png": 2603,
	"./spotlightRed.png": 2604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3760;